import { clsx } from "clsx";
import { memo } from "react";

export interface MediaPlayheadProps {
  disableMotion?: boolean;
  distance: number;
  isActive?: boolean;
}

export const MediaPlayhead = memo(function MediaPlayhead({
  disableMotion,
  distance,
  isActive,
}: MediaPlayheadProps) {
  return (
    <div
      className={clsx("MediaPlayhead", {
        "MediaPlayhead--active": isActive,
        "MediaPlayhead--motion": !disableMotion,
      })}
      style={{
        transform: `translateX(${distance}px)`,
      }}
    />
  );
});
